import {DesignViewController} from './design-view.controller';
import template from './design-view.template.html';

export const DesignViewComponent = {
    controller: DesignViewController,
    templateUrl: template
};



// WEBPACK FOOTER //
// ./src/js/views/design-view/design-view.component.js